<template>
  <div>
    <h5>Подтверждение кода из смс</h5>
    <fg-input
      :type="`number`"
      :label="`Введите код из смс, которое пришло клиенту`"
      v-model="code"
    ></fg-input>
    <br />
    <br />
    <button @click="next" class="btn btn-info mw">
      {{ "next_step" | setText("Далее") }}
    </button>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  data() {
    return {
      code: "",
    };
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },

  methods: {
    next() {
      this.send();
    },
    async send(val) {
      this.$loading(true);

      //GET PARTNER
      let partner = await this.$http
        .get(`partners/${this.partner.id}?auth=TEST_AUTH`)
        .then((response) => {
          return response.data.data;
        });
      //GET PARTNER

      this.$http
        .post(
          `${partner["endpoint_url"]}clients/clients/create/verify`,
          {
            ...this.value,
            otp: this.code,
          },
          {
            headers: {
              Authorization: `Bearer ${partner["api_secret_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
              locale: this.$store.state.language_current,
            },
          }
        )
        .then(async (response) => {
          if (response.data && response.data.id) {
            await this.createTransaction({
              exchange_additional_id: response.data.id,
            });
            this.$emit("setStep", "client-detail");
            this.$emit("input", response.data);
          } else {
            alert("Ошибка подтверждения смс");
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
};
</script>



